"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = exports.SettingsType = void 0;
const toastProvider_1 = require("@/ui/toast/toastProvider");
const defaultLocalSettings_1 = __importDefault(require("@/assets/defaultLocalSettings"));
const defaultSessionSettings_1 = __importDefault(require("@/assets/defaultSessionSettings"));
const global_1 = require("./global");
const utils_1 = require("./utils/utils");
const event_1 = require("./event");
var SettingsType;
(function (SettingsType) {
    // eslint-disable-next-line no-unused-vars
    SettingsType[SettingsType["LOCAL"] = 0] = "LOCAL";
    SettingsType[SettingsType["SESSION"] = 1] = "SESSION";
})(SettingsType || (exports.SettingsType = SettingsType = {}));
class Settings {
    constructor() {
        // events
        this._onDidChange = new event_1.Emitter();
        this._local = window.localStorage;
        this._session = window.sessionStorage;
        this._localSettings = (0, utils_1.deepClone)(defaultLocalSettings_1.default);
        this._sessionSettings = (0, utils_1.deepClone)(defaultSessionSettings_1.default);
        this._initializeSettings(SettingsType.LOCAL);
        this._initializeSettings(SettingsType.SESSION);
    }
    _useSettings(type) {
        return [
            type === SettingsType.LOCAL ? this._local : this._session,
            type === SettingsType.LOCAL ? this._localSettings : this._sessionSettings
        ];
    }
    _initializeSettings(type) {
        const [storage] = this._useSettings(type);
        const storedSettings = storage.getItem(global_1.settingsStorageKey);
        if (!storedSettings) {
            this._storeToStorage(type);
            toastProvider_1.toastProvider.showTitleToast("欢迎使用 Motive!", "已初始化设置", Infinity);
        }
        else {
            this._loadFromStorage(type);
        }
    }
    _loadFromStorage(type) {
        const [storage, settingsList] = this._useSettings(type);
        const storedSettings = JSON.parse(storage.getItem(global_1.settingsStorageKey) || "{}");
        for (const key in storedSettings) {
            if (settingsList[key]) {
                settingsList[key].value = storedSettings[key];
            }
        }
    }
    _storeToStorage(type) {
        const [storage, settingsList] = this._useSettings(type);
        const settingsMap = Object.fromEntries(Object.entries(settingsList).map(([key, item]) => [key, item.value]));
        storage.setItem(global_1.settingsStorageKey, JSON.stringify(settingsMap));
    }
    addItem(key, item, type = SettingsType.LOCAL) {
        const [, settingsList] = this._useSettings(type);
        settingsList[key] = item;
        this._storeToStorage(type);
    }
    hasKey(key, type = SettingsType.LOCAL) {
        const [, settingsList] = this._useSettings(type);
        return key in settingsList;
    }
    getValue(key, type = SettingsType.LOCAL) {
        const [, settingsList] = this._useSettings(type);
        return settingsList[key].value;
    }
    setValue(key, value, type = SettingsType.LOCAL) {
        const [, settingsList] = this._useSettings(type);
        settingsList[key].value = value;
        this._storeToStorage(type);
    }
    getList(type) {
        const [, settingsList] = this._useSettings(type);
        return settingsList;
    }
    storeList(list, type = SettingsType.LOCAL) {
        const [, settingsList] = this._useSettings(type);
        const oldSettingsList = (0, utils_1.deepClone)(settingsList);
        Object.assign(settingsList, list);
        this._storeToStorage(type);
        for (const key in list) {
            const isChanged = oldSettingsList[key].value !== list[key].value;
            if (isChanged) {
                this._onDidChange.fire({ key, value: list[key].value });
            }
        }
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    static get() {
        if (!Settings._instance)
            Settings._instance = new Settings();
        return Settings._instance;
    }
}
exports.Settings = Settings;
Settings._instance = null;
